import axios from "@/axios";

export default {
    bonus() {
        return axios.post('notifications/bonus');
    },
    newBonus() {
        return axios.get('notifications/new-bonus');
    },
}